<template>
  <WhitePage :loading="$store.getters.loading">
    <title-bar>プロフィール</title-bar>
    <!-- <setting-nav></setting-nav> -->
    <b-form>
      <b-form-group id="nickname" label="愛称">
        <b-form-input v-model="form.nickname"></b-form-input>
      </b-form-group>
      <b-form-group id="name" label="名前">
        <b-form-input v-model="form.name"></b-form-input>
      </b-form-group>
      <b-form-group id="memo" label="メモ">
        <b-form-input v-model="form.memo"></b-form-input>
      </b-form-group>
      <b-form-group id="note" label="説明">
        <remark-editor class="editor" v-model="form.note"
          :danger="1000" :warn="800"
        ></remark-editor>
      </b-form-group>
      <!-- <b-form-group id="icon" label="基本アイコン">
        <icon-dropdown :list="iconList" v-model="form.icon"
          width="300px" height="75px"
        /><br>
        <b-form-checkbox id="iconR" name="iconR"
          v-model="form.iconR"
          value="1"
          unchecked-value="0"
        >
          逆サイド反転フラグ
        </b-form-checkbox>
      </b-form-group> -->
      <b-form-group id="image" label="プロフィール画像">
        <b-form-input v-model="form.image" debounce="500"></b-form-input>
        <b-img :src="form.image" width="210" height="300" fluid></b-img>
      </b-form-group>
      <b-button type="button" variant="primary" @click="onSubmit">登録</b-button>
      <response-message :value="postMessage" />
    </b-form>
  </WhitePage>
</template>

<script>
import phina from 'phina.js'
import store from '@/store'
import WhitePage from '@/components/WhitePage'
import CheckLogin from '@/components/mixin-checkLogin'
import TitleBar from '@/components/TitleBar'
import ResponseMessage from '@/components/ResponseMessage'
// import SettingNav from '@/components/SettingNav'
import RemarkEditor from '@/components/RemarkEditor'
export default {
  components: {
    WhitePage,
    TitleBar,
    ResponseMessage,
    // SettingNav,
    RemarkEditor
  },
  data () {
    return {
      form: {
        nickname: null,
        name: null,
        memo: null,
        note: null,
        image: null
      },
      player: null,
      loading: false,
      postMessage: {}
    }
  },
  mixins: [
    CheckLogin
  ],
  methods: {
    setData (response) {
        this.form.nickname = response.nickname
        this.form.name = response.name
        this.form.memo = response.memo
        this.form.note = response.note
        this.form.image = response.image
        this.player = response.player
    },
    onSubmit () {
      this.$store.dispatch('setProfile', this.form)
        .then((response)=>{
          this.postMessage = response
        })
    }
  },
  beforeRouteEnter (route, redirect, next) {
    store.dispatch('getProfile', {})
      .then((response) => {
        next(vm => vm.checkService(response))        
      })
  },
  created () {
    this.checkLogin()
  },
  mounted () {
    phina.global.app.currentScene.exit('MainScene')
  }
}
</script>

<style lang="scss" scoped>
// .editor {
//   width: 420px;
//   height: 100px;
// }
</style>
